import { GetterTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { ITenantState } from './tenant-state.store';

export const getters: GetterTree<ITenantState, IRootState> = {
  tenants: (state: ITenantState) => state.tenants,
  service: (state: ITenantState) => state.service,
  currentTenant: (state: ITenantState) => state.currentTenant,
}


// WEBPACK FOOTER //
// ./src/store/tenant/tenant-getters.store.ts